import React, { useState } from "react";
import { FaCopy, FaCheck } from "react-icons/fa";
import NavbarAll from "../Navbar/NavbarAll";
import DonationForm from "./DonationForm";
import "./donate.css";

const copyToClipboard = (text, onCopied) => {
  navigator.clipboard.writeText(text).then(() => {
    onCopied(true);
    setTimeout(() => onCopied(false), 2000);
  });
};

const BankAccountCard = ({ title, accounts }) => (
  <div className="donate-account-card">
    <h4>{title}</h4>
    <div className="donate-accounts">
      {accounts.map((account, index) => (
        <BankAccountRow key={index} account={account} />
      ))}
    </div>
  </div>
);

const BankAccountRow = ({ account }) => {
  const [copiedField, setCopiedField] = useState(null);

  return (
    <div className="donate-account-grid">
      <div className="donate-account-item">
        <span>Account Title</span>
        <strong>{account.accountTitle}</strong>
      </div>
      <div className="donate-account-item">
        <span>Bank</span>
        <strong>{account.bankName}</strong>
      </div>
      <div className="donate-account-item">
        <span>Account Number</span>
        <div className="donate-copy-row">
          <strong className="donate-copy-value">{account.accountNumber}</strong>
          <button
            type="button"
            className={`donate-copy-icon-btn ${copiedField === "account" ? "copied" : ""}`}
            onClick={() => copyToClipboard(account.accountNumber, (v) => setCopiedField(v ? "account" : null))}
            title="Copy"
            aria-label="Copy account number"
          >
            {copiedField === "account" ? <FaCheck /> : <FaCopy />}
          </button>
        </div>
      </div>
      <div className="donate-account-item donate-account-item-iban">
        <span>IBAN</span>
        <div className="donate-copy-row">
          <strong className="donate-copy-value donate-copy-value-iban">{account.iban}</strong>
          <button
            type="button"
            className={`donate-copy-icon-btn ${copiedField === "iban" ? "copied" : ""}`}
            onClick={() => copyToClipboard(account.iban, (v) => setCopiedField(v ? "iban" : null))}
            title="Copy"
            aria-label="Copy IBAN"
          >
            {copiedField === "iban" ? <FaCheck /> : <FaCopy />}
          </button>
        </div>
      </div>
    </div>
  );
};

const BankAccountDetails = () => {
  const donationAccounts = [
    {
      bankName: "Meezan Bank Ltd",
      accountTitle: "Khadija tul Kubra Welfare Trust",
      accountNumber: "0109647702",
      branchCode: "9942",
      iban: "PK45MEZN0099420109647702",
    },
    {
      bankName: "Dubai Islamic",
      accountTitle: "Khadija tul Kubra Welfare Trust",
      accountNumber: "0541031001",
      branchCode: "127",
      iban: "Pk25DUIB0000000541031001",
    },
  ];

  const zakatAccounts = [
    {
      bankName: "Meezan Bank Ltd",
      accountTitle: "Khadija tul Kubra Welfare Trust Association - Zakat",
      accountNumber: "0109647667",
      branchCode: "9942",
      iban: "PK20MEZN0099420109647667",
    },
  ];

  return (
    <>
      <NavbarAll />
      <div className="donate-page">
        <div className="donate-hero">
          <h1>Donate</h1>
          <p>Your contribution helps us serve those in need. Donate online or use our bank details below.</p>
        </div>

        <div className="donate-inner">
          <DonationForm />

          <h2 className="donate-section-title">Bank Account Details</h2>

          <div className="donate-section">
            <BankAccountCard title="Donation Accounts" accounts={donationAccounts} />
          </div>

          <div className="donate-section">
            <BankAccountCard title="Zakat Accounts" accounts={zakatAccounts} />
          </div>
        </div>
      </div>
    </>
  );
};

export default BankAccountDetails;
